import {
  Game,
  GameList,
  PastPitchData,
  Pitch,
  Pitcher,
  PitcherLog,
  PitchHistory,
  Player,
  PlayerWithGame
} from './utilTypes';
import {fourDays} from './util';


type PitchAble = {
  pitcher: number;
  catcher: number;
  isFortyOver: boolean;
};

export type PitchData = {
  pitcherAble: number;
  totalPitch: number;
  isFortyOver: boolean;
  isTodayPitch: boolean;
};

export type PitcherInfo = {
  totalPitch: number,
  pitchAbleGameNum: number,
  ablePitch: number,
};

export class PitchCheck {

  private static _instance: PitchCheck;

  private constructor() {
  }

  static get instance() {
    if(!this._instance){
      this._instance = new PitchCheck();
    }
    return this._instance;
  }

  createGameList(gameDaysList: string[], gameList: Game[]): GameList[]{
    const gameList2: GameList[] = [];
    for (const day of gameDaysList) {
      const gameListContent: GameList = {
        day: 'XX/XX',
        game1: { datetime: '----' },
        game2: { datetime: '----' }
      };
      const date = new Date(day);
      const list = gameList.filter(v => new Date(v.dateTime).toLocaleDateString() === date.toLocaleDateString())
        .sort((a, b) => {
          return Date.parse(a.dateTime) - Date.parse(b.dateTime);
        });
      gameListContent.day = date.toLocaleDateString();
      if (list[0]) {
        const newDateInfo = new Date(list[0].dateTime);
        const minute = '00' + String(newDateInfo.getMinutes());
        gameListContent.game1.datetime = `${newDateInfo.getHours()}:${minute.slice(-2)}`;
        // gameListContent.game1.gameNum = list[0].gameNum;
      }
      if (list[1]) {
        const newDateInfo = new Date(list[1].dateTime);
        const minute = '00' + String(newDateInfo.getMinutes());
        gameListContent.game2.datetime = `${newDateInfo.getHours()}:${minute.slice(-2)}`;
        // gameListContent.game2.gameNum = list[1].gameNum;
      }
      gameList2.push(gameListContent);
    }
    return gameList2;
  }
  
  // 該当大会における当日を含む4日間の試合を試合順に列挙する
  gameFourDays(games: Game[], dateInfo: string): Game[] {
    const dayList = fourDays(dateInfo);
    const gameResult: Game[] = [];
    for (const day of dayList) {
      for (const game of games) {
        const changedToDate = new Date(game.dateTime);
        if (changedToDate.toLocaleDateString() === day) {
          gameResult.push(game);
        }
      }
    }
    return gameResult.sort((a, b) => {
      return Date.parse(a.dateTime) - Date.parse(b.dateTime);
    });
  }

  // ピッチャーリストに各ピッチャーごとの登板履歴を付与する
  createPlayerList(players: Player[], games:Game[]): PlayerWithGame[] {
    const playerWithGameList: PlayerWithGame[] = [];
    for(const player1 of players) {
      const playerWithGame: PlayerWithGame = {player: player1, game: []};
      for (const game of games) {
        const pitch = game.pitches.find(v1 => v1.playerId === player1.id);
        if (pitch) {
          playerWithGame.game.push({dateTime: game.dateTime, pitch: pitch.pitchNum});
        }
      }
      playerWithGameList.push(playerWithGame);
    }
    return playerWithGameList;
  }

  // ひとりの投手の登板情報と登板可否を返す
  pitchAble(player: PlayerWithGame, dateInfo: string): Pitcher {
    const [targetDay, oneDayAgo, twoDaysAgo, threeDaysAgo] = fourDays(dateInfo);
    // 該当日含む4日間までの投手としての出場記録を取り出す
    const pastPitchData = player.game
      .filter((v) => {
        return (
          new Date(v.dateTime).toLocaleDateString() === targetDay ||
          new Date(v.dateTime).toLocaleDateString() === oneDayAgo ||
          new Date(v.dateTime).toLocaleDateString() === twoDaysAgo ||
          new Date(v.dateTime).toLocaleDateString() === threeDaysAgo
        );
      })
      .sort((a, b) => {
        return Date.parse(a.dateTime) - Date.parse(b.dateTime);
      });
    // console.log(pastPitchData);
    // 登板履歴と状態値の返却
    if (pastPitchData) {
      const days = [threeDaysAgo, twoDaysAgo, oneDayAgo, targetDay];
      const pitchData = PitchCheck.judge(days, pastPitchData, dateInfo);
      // console.log(PitchCheck.restPitchNum(pitchData));
      return {
        player: player.player,
        game: pastPitchData,
        pitchAble: PitchCheck.todayCondition(pitchData)
      };
    } else {
      return  {player: player.player, game: [], pitchAble: null };
    }
  }

  // 登板有無と内容判定
  static judge(days: string[], pastPitchData: PastPitchData[], dateInfo: string): PitchData {
    let pitchData: PitchData = { pitcherAble: 3, totalPitch: 0, isFortyOver: false, isTodayPitch: false};
    for (const date of days) {
      const dateString = new Date(dateInfo).toLocaleDateString();
      // console.log(date);
      // console.log(dateString);
      if (pastPitchData.filter(value => value.dateTime.split(' ')[0] === date).length) {
        // console.log(playedPitcher(pastPitchData, date).length);
        // console.log(date === dateString)
        pitchData.isTodayPitch = (date === dateString);
        for (const v of pastPitchData) {
          const dateTimeString = new Date(v.dateTime).toLocaleDateString();
          if (dateTimeString === date) {
            const judged = PitchCheck.pastPitchCheck(pitchData.pitcherAble, v.pitch!, pitchData.isFortyOver);
            pitchData.pitcherAble = judged.pitcher;
            pitchData.totalPitch += v.pitch!;
            pitchData.isFortyOver = judged.isFortyOver;
          }
        }
      } else {
        if (date !== dateString) {
          pitchData.pitcherAble = 3;
          pitchData.totalPitch = 0;
          pitchData.isFortyOver = false;
        } else {
          if ( pitchData.isFortyOver && pitchData.pitcherAble === 0 && pitchData.totalPitch < 120 ) {
            pitchData.pitcherAble = 1;
          }
        }
      }
    }
    // console.log(pitchData);
    return pitchData;
  }

  // 登板状態から次の登板可否結果を出す
  static pastPitchCheck(pitchAbleScore: number, todayGamePitch: number, isForty: boolean ): PitchAble {
    let fortyOver = isForty;
    // 球数で連投可能数を処理
    if (pitchAbleScore !== 0) {
      if (todayGamePitch <= 40) {
        pitchAbleScore -= 1;
      } else if (todayGamePitch >= 80) {
        pitchAbleScore = 0;
        fortyOver = true;
      } else {
        pitchAbleScore -= 2;
        fortyOver = true;
      }
    }
    // 結果を判定
    if (pitchAbleScore <= 0) {
      return {pitcher: 0, catcher: 0, isFortyOver: fortyOver};
    } else {
      return {pitcher: pitchAbleScore, catcher: 1, isFortyOver: fortyOver};
    }
  }

  // 当日の登板条件
  private static todayCondition(pitchData: PitchData ): PitcherInfo {
    if (pitchData.pitcherAble === 0 ) {
      return { totalPitch: pitchData.totalPitch, pitchAbleGameNum: pitchData.pitcherAble, ablePitch: 0};
    } else if ( pitchData.pitcherAble === 1 && pitchData.isFortyOver && !pitchData.isTodayPitch) {
      const pitchNum = pitchData.totalPitch > 80 ? 40 : 120 - pitchData.totalPitch;
      return { totalPitch: pitchData.totalPitch, pitchAbleGameNum: pitchData.pitcherAble, ablePitch: pitchNum};
    } else if ( pitchData.pitcherAble === 1 && pitchData.isFortyOver && pitchData.isTodayPitch) {
      const pitchNum = pitchData.totalPitch > 80 ? 0 : 80 - pitchData.totalPitch;
      return { totalPitch: pitchData.totalPitch, pitchAbleGameNum: pitchData.pitcherAble, ablePitch: pitchNum};
    } else if ( pitchData.pitcherAble === 1 && !pitchData.isFortyOver) {
      return { totalPitch: pitchData.totalPitch, pitchAbleGameNum: pitchData.pitcherAble, ablePitch: 40};
    } else if (pitchData.pitcherAble === 2 && !pitchData.isFortyOver && pitchData.isTodayPitch) {
      const pitchNum = pitchData.totalPitch > 80 ? 0 : 80 - pitchData.totalPitch;
      return { totalPitch: pitchData.totalPitch, pitchAbleGameNum: pitchData.pitcherAble, ablePitch: pitchNum};
    } else {
      return { totalPitch: pitchData.totalPitch, pitchAbleGameNum: pitchData.pitcherAble, ablePitch: 80};
    }
  }
  
  // 当日の残り投球可能数
  private static restPitchNum(pitchData: PitchData ): number {
    if (pitchData.pitcherAble === 0 ) {
      return 0;
    } else if ( pitchData.pitcherAble === 1 && pitchData.isFortyOver && !pitchData.isTodayPitch) {
      const pitchNum = 120;
      return pitchNum;
    } else if ( pitchData.pitcherAble === 1 && pitchData.isFortyOver && pitchData.isTodayPitch) {
      const pitchNum = 80;
      return pitchNum;
    } else if ( pitchData.pitcherAble === 1 && !pitchData.isFortyOver) {
      return 40 - pitchData.totalPitch;;
    } else if (pitchData.pitcherAble === 2 && !pitchData.isFortyOver && pitchData.isTodayPitch) {
      const pitchNum = 80;
      return pitchNum;
    } else {
      return 80 - pitchData.totalPitch;;
    }
  }
  
  
  // 該当投手の4日間登板データと最新の登板可否情報のソートと整形
  pitcherFourDays(pitcher: Pitcher, targetDay: string): PitchHistory {
    const days: string[] = fourDays(targetDay);
    const games: PastPitchData[][] = [];
    for (const day of days) {
      const pastPitchData = pitcher.game.filter(value => new Date(value.dateTime).toLocaleDateString() === day);
      pastPitchData.sort((a, b) => {
        return Date.parse(a.dateTime) - Date.parse(b.dateTime);
      });
      games.push(pastPitchData);
    }
    return {
      player:pitcher.player, pitchAble: pitcher.pitchAble!,
      beforeThreeDays: games[3], beforeTwoDays: games[2],
      beforeOneDay: games[1], targetDay: games[0],
    };
  }
  
  // 投手の状態リストを返す
  createPitchersLog(pitchHistory: PitchHistory[], dayList: GameList[]): PitcherLog[] {
    const pitcherLogs: PitcherLog[] = [];
    for (const pitcher of pitchHistory) {
      const three: PastPitchData[] = [];
      const two: PastPitchData[] = [];
      const one: PastPitchData[] = [];
      const target: PastPitchData[] = [];
      three.push(pitcher.beforeThreeDays.filter(value => value.dateTime?.includes(dayList[3]?.game1.datetime))[0]);
      three.push(pitcher.beforeThreeDays.filter(value => value.dateTime?.includes(dayList[3]?.game2.datetime))[0]);
      two.push(pitcher.beforeTwoDays.filter(value => value.dateTime?.includes(dayList[2]?.game1.datetime))[0]);
      two.push(pitcher.beforeTwoDays.filter(value => value.dateTime?.includes(dayList[2]?.game2.datetime))[0]);
      one.push(pitcher.beforeOneDay.filter(value => value.dateTime?.includes(dayList[1]?.game1.datetime))[0]);
      one.push(pitcher.beforeOneDay.filter(value => value.dateTime?.includes(dayList[1]?.game2.datetime))[0]);
      target.push(pitcher.targetDay.filter(value => value.dateTime?.includes(dayList[0]?.game1.datetime))[0]);
      target.push(pitcher.targetDay.filter(value => value.dateTime?.includes(dayList[0]?.game2.datetime))[0]);
      
      pitcherLogs.push({
        player:pitcher.player, pitchAble: pitcher.pitchAble,
        pitch3: three, pitch2: two, pitch1: one, pitch0: target
      });
    }
    // console.log(pitcherLogs)
    return pitcherLogs;
  }
  
  
}
